import { useEffect, useRef, useState } from "react";

function useInViewport({ threshold = 0.1, root = null, rootMargin = "0px", once = true } = {}) {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    if (once) observer.disconnect();
                } else if (!once) {
                    setInView(false);
                }
            },
            {
                threshold,
                root,
                rootMargin,
            }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => observer.disconnect();
    }, [threshold, root, rootMargin, once]);

    return [ref, inView];
}

export default useInViewport;
